<ion-card>
    <ion-fab vertical="center" horizontal="end"> 
        <ion-fab-button *ngIf="document.documentNumber === 0" (click)="openModalSearch()" size="small" color="light">
            <ion-icon name="person"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-card-content *ngIf="!document.contact.name" (click)="openModalSearch()">
        <ion-label>Select contact...</ion-label>
    </ion-card-content>


    <ion-card-content *ngIf="(!document.contact.name || document.contact.name === '' ) && ( !document.contact.phone || document.contact.phone ==='' )">
        <h4  style="color: #ee1111"><strong>NO CONTACT !!!</strong></h4>
    </ion-card-content>

    <ion-card-content *ngIf="(document.contact.name && document.contact.name !== '' )|| ( document.contact.phone && document.contact.phone !=='') ">
        <ion-row class="ion-no-padding ion-no-margin">
            <ion-col size="9" class="ion-no-padding ion-no-margin">
                {{ document.contact.name }}
            </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center ion-no-padding ion-no-margin" *ngIf="document.contact.phone">
            <ion-col size="6" class="ion-no-padding ion-no-margin">
                {{ document.contact.phone }}
            </ion-col>
            <ion-col size="3" *ngIf="document.contact.phone" class="ion-no-padding ion-no-margin">
                <ion-chip (click)="callContact.callContact(document.contact.phone)" class="ion-float-right" color="success">
                    Call
                    <ion-icon name="call"></ion-icon>
                </ion-chip>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="document.contact.email" class="ion-no-padding ion-no-margin">
            <ion-col class="ion-no-padding ion-no-margin">
                {{ document.contact.email }}
            </ion-col>
        </ion-row>
    </ion-card-content>
</ion-card>
